import brazilianBanks from './brazilian-banks.json';

export type BrazilianBank = {
    code: string;
    name: string;
};

export const BrazilianBanks: BrazilianBank[] = brazilianBanks;

/** Options for mat-select — value is the COMPE code (e.g. "001"). */
export const BrazilianBankOptions = BrazilianBanks.map((bank) => ({
    value: bank.code,
    label: `${bank.code} - ${bank.name}`,
}));
